export interface Co2Data {
  code: string;
  co2Intensity: number | null;
}
export const co2Data: Co2Data[] = [
  { code: 'AD', co2Intensity: null },
  { code: 'AE', co2Intensity: null },
  { code: 'AL', co2Intensity: null },
  { code: 'AM', co2Intensity: null },
  { code: 'AR', co2Intensity: 292.18361488296307 },
  { code: 'AT', co2Intensity: 166.14507710980976 },
  { code: 'AUS', co2Intensity: 531.8117070326 },
  { code: 'AW', co2Intensity: 586.0518706742527 },
  { code: 'AX', co2Intensity: 35.08491127435865 },
  { code: 'BA', co2Intensity: 587.3093539899021 },
  { code: 'BD', co2Intensity: null },
  { code: 'BE', co2Intensity: 246.39095659387763 },
  { code: 'BG', co2Intensity: 285.82449732894685 },
  { code: 'BH', co2Intensity: null },
  { code: 'BO', co2Intensity: 524.1167663047245 },
  { code: 'BR', co2Intensity: 99.4854272555503 },
  { code: 'BY', co2Intensity: null },
  { code: 'CA', co2Intensity: 241.03345892249652 },
  { code: 'CH', co2Intensity: null },
  { code: 'CL', co2Intensity: 390.97002964671043 },
  { code: 'CR', co2Intensity: 49.63138386413542 },
  { code: 'CY', co2Intensity: null },
  { code: 'CZ', co2Intensity: 356.19549619016976 },
  { code: 'DE', co2Intensity: 339.9501801567928 },
  { code: 'DK', co2Intensity: 85.08475467177907 },
  { code: 'DO', co2Intensity: 630.6744570391999 },
  { code: 'EE', co2Intensity: 323.5372706991845 },
  { code: 'ES', co2Intensity: 514.3012955044283 },
  { code: 'FI', co2Intensity: 116.76578635958754 },
  { code: 'FO', co2Intensity: 272.7900960638315 },
  { code: 'FR', co2Intensity: 81.77481142053831 },
  { code: 'GB', co2Intensity: 208.33301523816422 },
  { code: 'GE', co2Intensity: 105.24658805868008 },
  { code: 'GF', co2Intensity: null },
  { code: 'GP', co2Intensity: null },
  { code: 'GR', co2Intensity: null },
  { code: 'GT', co2Intensity: 82.20052232025844 },
  { code: 'HN', co2Intensity: 308.8859564598359 },
  { code: 'HR', co2Intensity: 197.6959534616194 },
  { code: 'HU', co2Intensity: 252.0726897837512 },
  { code: 'IE', co2Intensity: 285.5468755121074 },
  { code: 'IL', co2Intensity: 580 },
  { code: 'IN', co2Intensity: 569.5090862382177 },
  { code: 'IQ', co2Intensity: null },
  { code: 'IS', co2Intensity: 28.06553981398297 },
  { code: 'IT', co2Intensity: 379.2774376790185 },
  { code: 'JP', co2Intensity: 460.6555585760024 },
  { code: 'KR', co2Intensity: 540.0622352666691 },
  { code: 'KW', co2Intensity: 595 },
  { code: 'LT', co2Intensity: 213.25779085856664 },
  { code: 'LU', co2Intensity: null },
  { code: 'LV', co2Intensity: 296.93160707173223 },
  { code: 'MD', co2Intensity: 663.9032491395739 },
  { code: 'ME', co2Intensity: 540.215015897711 },
  { code: 'MK', co2Intensity: null },
  { code: 'MQ', co2Intensity: null },
  { code: 'MT', co2Intensity: null },
  { code: 'MX', co2Intensity: null },
  { code: 'MY', co2Intensity: 684.6790921122762 },
  { code: 'NA', co2Intensity: null },
  { code: 'NI', co2Intensity: 177.87445689120818 },
  { code: 'NKR', co2Intensity: null },
  { code: 'NL', co2Intensity: null },
  { code: 'NO', co2Intensity: 32.68569249005339 },
  { code: 'NP', co2Intensity: null },
  { code: 'NZ', co2Intensity: 138.38411494771134 },
  { code: 'OM', co2Intensity: null },
  { code: 'PA', co2Intensity: 167.19660542267718 },
  { code: 'PE', co2Intensity: null },
  { code: 'PL', co2Intensity: 622.0988546685193 },
  { code: 'PT', co2Intensity: 337.39755094850966 },
  { code: 'QA', co2Intensity: null },
  { code: 'RE', co2Intensity: null },
  { code: 'RO', co2Intensity: 274.62370920798736 },
  { code: 'RS', co2Intensity: 516.0986866305687 },
  { code: 'RU', co2Intensity: 391.322730052394 },
  { code: 'SA', co2Intensity: null },
  { code: 'SE', co2Intensity: 38.14091160001278 },
  { code: 'SG', co2Intensity: 495.67198944744024 },
  { code: 'SI', co2Intensity: 248.19272024586428 },
  { code: 'SK', co2Intensity: 257.5847005600654 },
  { code: 'SV', co2Intensity: 92.67428366590262 },
  { code: 'TR', co2Intensity: 459.5307217944542 },
  { code: 'TW', co2Intensity: 569.684568251526 },
  { code: 'UA', co2Intensity: 269.2357070623862 },
  { code: 'US', co2Intensity: 376.2800721845858 },
  { code: 'UY', co2Intensity: 49.08338856493782 },
  { code: 'ZZ', co2Intensity: 321.0402146851803 },
];
